import { FaEllipsisV, FaEdit, FaTrash } from "react-icons/fa";
import toast from "react-hot-toast";
import { Layout } from "@/Api/genApi.schemas";
import { useDeleteLayouts } from "@/Api/genApi";
import { useAppDispatch } from "@/Store/hooks";
import { RefreshCache } from "@/legacy/ApiCallerOld";
import { Popover, PopoverContent, PopoverTrigger } from "@shared/lib/floating/PopoverComponents";

interface LayoutListItemProps {
	layout: Layout;
	onSelect(layout: Layout): void;
	editLayout(): void;
	isActive?: boolean;
	disableOptions?: boolean;
}

export function LayoutListItem(props: LayoutListItemProps) {
	const deleteLayouts = useDeleteLayouts();
	const dispatch = useAppDispatch();

	async function deleteLayout() {
		if (props.layout.id != null) {
			deleteLayouts.mutate(
				{ id: props.layout.id },
				{
					onSuccess: async () => {
						await RefreshCache(dispatch);
						toast.success("Layout deleted.");
					},
					onError: (error) => {
						toast.error("Could not delete layout: " + error.errorMsg);
					}
				}
			);
		}
	}

	const activeStyles = props.isActive ? "bg-blue-50 font-bold" : "";

	return (
		<div className={"flex items-center cursor-pointer hover:bg-blue-100 active:bg-blue-200 rounded-lg " + activeStyles} >
			<div
				className="text-sm grow p-2"
				onClick={() => {
					props.onSelect(props.layout);
				}}
			>
				{props.layout.name}
			</div>
			{!props.disableOptions &&
				<PopoverOption
					onEdit={props.editLayout}
					onRemove={deleteLayout}
				/>}
		</div>
	);
}

interface PopoverOptionProps {
	onEdit(): void;
	onRemove(): void;
}

function PopoverOption(props: PopoverOptionProps) {
	const { onEdit, onRemove } = props;

	return (
		<Popover placement="bottom">
			<PopoverTrigger>
				<button className="py-1 px-2 rounded-md hover:bg-gray-200 text-sm">
					<FaEllipsisV />
				</button>
			</PopoverTrigger>
			<PopoverContent className="bg-white border border-gray-200 rounded-lg shadow-lg w-40 mt-2">
				<div className="flex flex-col">
					<button
						onClick={onEdit}
						className="flex items-center gap-2 px-3 py-2 hover:bg-gray-100 text-sm"
					>
						<FaEdit className="text-gray-600" />
						<span>Edit</span>
					</button>
					<button
						onClick={onRemove}
						className="flex items-center gap-2 px-3 py-2 hover:bg-gray-100 text-red-600 text-sm"
					>
						<FaTrash />
						<span>Remove</span>
					</button>
				</div>
			</PopoverContent>
		</Popover>
	);
}
